const classPrefix = 'customer-support'
const dataPrefix = 'data-customer-support'


export function customerSupport($container) {

}
